<template>
  <div>
    <m-row>
      <m-col lg="12">
        <WebBuilderContainer
          class="builder-container"
          ref="container"
          :components="components" 
          max_width="800px"
          @update-components="updateComponents"
        />
      </m-col>
    </m-row>
  </div>
</template>


<script>
import axios from 'axios';

import { mapGetters } from 'vuex';

// The render view.
import WebBuilderContainer from '@/view/components/web_builder/WebBuilderContainer.vue';

// Toolbar which has all tools we need.
import WebBuilderToolbar from '@/view/components/web_builder/WebBuilderToolbar.vue';

export default {
  name: 'WebBuilderExample',
  components: {
    WebBuilderContainer,
    WebBuilderToolbar,
  },
  props: {

  },
  computed: {

  },
  data() {
    return {
      components: [] // Array to store dynamic components added by the user
    };
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    updateComponents(index, newComponent) {
      // Insert the new component at the correct position
      this.components.splice(index, 0, newComponent); // Insert at the correct index
    }
  }
};
</script>
<style scoped>
.builder-container {
  min-height: 200px;
  border: 1px solid black;
}
</style>
